export default __webpack_public_path__ + "static/media/meeting-lsbd.757bcca4.jpg";